import { render, staticRenderFns } from "./CategoriesSubNavbarSidebar.vue?vue&type=template&id=527177bd&scoped=true"
import script from "./CategoriesSubNavbarSidebar.vue?vue&type=script&lang=js"
export * from "./CategoriesSubNavbarSidebar.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSubNavbarSidebar.vue?vue&type=style&index=0&id=527177bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527177bd",
  null
  
)

export default component.exports